/* eslint-disable complexity */
import { CombinedErrorsObjectMap, ErrorsMapList, ServerErrors } from './errorsMap.ts';

import { router } from '@Routes/__root.tsx';
import { Icons } from '@Components/icon/Icon.tsx';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { ErrorModalTypes } from '@Types/error.types.ts';
import {
  reportErrorOccurredDuringOnboarding,
  reportFormErrorShown,
  reportWillViewExpireToken,
} from '@Services/analytics/GeneralAnalaytics.tsx';
import { AuthErrorMap } from '@Services/errors/auth.errors.ts';
export const handleServerError = (errorCode: number, localizedErrorMessage: string) => {
  const setFormFieldError = useBoundStore.getState().errorSlice.setFormFieldError;
  const setErrorModal = useBoundStore.getState().errorSlice.setErrorModal;
  const isFromLiliApp = useBoundStore.getState().onboardingSlice.isFromLiliApp;
  const routerData = useBoundStore.getState().onboardingSlice.routerData;

  reportErrorOccurredDuringOnboarding(
    errorCode,
    localizedErrorMessage,
    routerData.prevRoute,
    isFromLiliApp
  );
  const isErrorMapped = (error: number): error is ServerErrors => ErrorsMapList.includes(error);

  if (!isErrorMapped(errorCode)) {
    setErrorModal({
      error: 'An unknown error occurred',
      modalProps: {
        title: 'An unknown error occurred',
        content: 'Please try again later',
        icon: Icons.Oops,
        buttonText: 'Close',
        type: ErrorModalTypes.GENERAL,
      },
    });
  }
  const errorObject = CombinedErrorsObjectMap.get(errorCode);
  if (errorObject?.relatedFieldName) {
    setFormFieldError(
      errorObject.relatedFieldName,
      localizedErrorMessage ?? 'General error' //todo - in18 + text
    );
    reportFormErrorShown(errorObject.relatedFieldName, errorCode, localizedErrorMessage);
  }
  if (errorObject?.redirectPath) {
    router.navigate({ to: errorObject.redirectPath });
  }
  if (errorObject?.callBack) errorObject.callBack();
  if (errorObject?.openModal) {
    setErrorModal({
      error: errorCode.toString(),
      modalProps: errorObject.modalProps,
    });
  }
  reportAdditionalAnalytics(errorCode);
};
const reportAdditionalAnalytics = (errorCode: number) => {
  if (errorCode === AuthErrorMap.TOKEN_EXPIRED) {
    reportWillViewExpireToken(errorCode);
  }
};
